import type {
	ClientPropertyItemResponseDTO,
	PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { bucketPortfolioItems } from "web_myplann/Portfolio/Helpers/bucketPortfolioItems";
import {
	PORTFOLIO_CATEGORY_ORDER,
	type PortfolioCategoryId,
} from "web_myplann/Portfolio/Types/portfolioCategory";

export const availablePortfolioCategories = (
	portfolioItems: PortfolioListItemResponseDTO[],
	propertyItems: ClientPropertyItemResponseDTO[],
): PortfolioCategoryId[] => {
	const buckets = bucketPortfolioItems(portfolioItems, propertyItems);

	return PORTFOLIO_CATEGORY_ORDER.filter((id) => buckets[id].length > 0);
};
